/* global jQuery */

export default function SUProgressBarShortcode () {
  /*! <fs__only> */
  jQuery(function ($) {
    $('.sue-progress-bar.sue-progress-bar-animation').one('inview', function () {
      var $this = $(this)
      var $span = $this.children('span')
      var percent = $this.data('percent')
      $span.css('width', percent + '%')
    })
  })
  /*! </fs__only> */
}
